import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoaderService } from '@services/loader.service';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  private loaderService = inject(LoaderService);
  private requests: HttpRequest<unknown>[] = [];

  removeRequest(req: HttpRequest<unknown>): void {
    const i = this.requests.indexOf(req);
    if (i >= 0) this.requests.splice(i, 1);
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('assets')) return next.handle(request);

    this.requests.push(request);
    const hideSpinner = () => {
      this.requests.length === 0 && this.loaderService.toggleLoader(false);
    };
    const showSpinner = () => {
      this.requests.length > 0 && this.loaderService.toggleLoader(true);
    };

    return next.handle(request).pipe(
      tap({
        next: a => {
          if (a.type === HttpEventType.Sent) {
            showSpinner();
          }
          if (a.type === HttpEventType.Response) {
            this.removeRequest(request);
            hideSpinner();
          }
        },
        error: () => {
          this.requests = [];
        },
        finalize: () => {
          this.removeRequest(request);
          hideSpinner();
        }
      })
    );
  }
}
